<script>
    import NavBar from "../components/NavBar.svelte";

    let sms = 0;
    let contacts = 0;
    let mms = 0;
</script>

<div>
    <NavBar/>
    <div class="app-container">
        <div class="box">
            <h3 class="is-size-4 mb-3">Calculate Your Monthly Costs</h3>
            <hr>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label"># of Contacts</label>
                        <div class="control">
                            <input id="contacts" class="input" type="number" placeholder="e.g. 10" bind:value={contacts}>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label"># of SMS Messages</label>
                        <div class="control">
                            <input id="sms" class="input" type="number" placeholder="e.g. 200" bind:value={sms}>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label"># of MMS Messages</label>
                        <div class="control">
                            <input id="mms" class="input" type="number" placeholder="e.g. 25" bind:value={mms}>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <strong>Monthly SMS Cost:</strong>
            <br>
            Contacts ( { contacts } ) &times; SMS ( { sms } ) / month &times; USD$0.0079 = <strong>USD${ contacts * sms * 0.0079 }</strong>
            <br>
            <br>
            <strong>Monthly MMS Cost:</strong>
            <br>
            Contacts ( { contacts } ) &times; MMS ( { mms } ) / month &times; USD$0.02 = <strong>USD${ contacts * mms * 0.02 }</strong>
            <br>
            <br>
            <strong>Phone Number: USD$1.00/month</strong>
            <hr>
            <strong>Month Total: USD${contacts * sms * 0.0079 + contacts * mms * 0.02 + 1 }</strong>
            <br>
            <br>
            <strong>Month Total + GST(5%) + PST(7%): USD${ (contacts * sms * 0.0079 + contacts * mms * 0.02 + 1) * 1.12 }</strong>
        </div>
        <br>
    </div>
</div>